import React, { FC } from 'react'
import CommonGrid from '@mailstep/design-system/ui/Blocks/CommonGrid'
import GridExport, { Props as GridExportProps } from '@components/blocks/GridExport'
import { GridProps } from '@mailstep/design-system/ui/Blocks/CommonGrid/types'
import { useModal } from '@mailstep/design-system/ui/Blocks/Modal/hooks/useModal'
import useShallowRouting from './useShallowRouting'
import { getComparators } from './utils/getComparators'
import { CommonGridContainer } from '@components/blocks/CommonGrid/styles'

type StyledCommonGridProps = {
  onExport?: GridExportProps['onExport']
  headersOnlyOption?: boolean
}

export type Props = GridProps & StyledCommonGridProps

export type PageGridProps = Omit<
  GridProps,
  'rowsData' | 'totalRowsCount' | 'columnsDefinitions' | 'actionColumnDefinition' | 'minColumnWidth' | 'columnLayout'
> &
  StyledCommonGridProps

const StyledCommonGrid: FC<Props> = ({ onExport, headersOnlyOption, gridSelectors, gridActions, ...props }) => {
  const { onOpen: onExportClick, isOpen: exportFormVisible, onClose: hideExport } = useModal()

  const { changePathOrSetPage, rowsPerPageValue } = useShallowRouting(gridActions, gridSelectors)

  return (
    <CommonGridContainer>
      <CommonGrid
        processCheckedValues={onExport ? onExportClick : undefined}
        gridActions={gridActions}
        gridSelectors={gridSelectors}
        queryRowsParam={rowsPerPageValue}
        customPaginationHandler={changePathOrSetPage}
        comparators={getComparators()}
        {...props}
      />
      {!!onExport && exportFormVisible && (
        <GridExport
          onClose={hideExport}
          onExport={onExport}
          gridSelectors={gridSelectors}
          headersOnlyOption={headersOnlyOption}
        />
      )}
    </CommonGridContainer>
  )
}

export default StyledCommonGrid
